// import Swiper JS
import Swiper, { Autoplay, Navigation, Pagination, Thumbs } from 'swiper';
// import Swiper styles

(function ($) {

    if($('.post-gallery-slider').length > 0) {
        $('.post-gallery-slider .elementor-image-gallery').addClass('swiper');
        $('.post-gallery-slider .elementor-image-gallery').clone().addClass('thumbs').appendTo('.post-gallery-slider');
        $('.post-gallery-slider .elementor-image-gallery:first').addClass('first');
        $('.post-gallery-slider .elementor-image-gallery.first').append('<div class="swiper-button-next"><svg width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg replaced-svg"><path d="M0.466135 26.5351C0.768924 26.8397 1.18327 27 1.58167 27C1.98008 27 2.39442 26.8397 2.69721 26.5351L14.5378 14.6242C14.8406 14.3196 15 13.9188 15 13.502C15 13.0852 14.8406 12.6844 14.5378 12.3798L2.69721 0.468903C2.0757 -0.156301 1.08765 -0.156301 0.466135 0.468903C-0.155378 1.09411 -0.155378 2.08802 0.466135 2.71323L11.1912 13.502L0.466135 24.2908C-0.139442 24.916 -0.139442 25.9259 0.466135 26.5351Z" fill="#2E2E2D"></path></svg></div><div class="swiper-button-prev"><svg width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg replaced-svg"><path d="M0.466135 26.5351C0.768924 26.8397 1.18327 27 1.58167 27C1.98008 27 2.39442 26.8397 2.69721 26.5351L14.5378 14.6242C14.8406 14.3196 15 13.9188 15 13.502C15 13.0852 14.8406 12.6844 14.5378 12.3798L2.69721 0.468903C2.0757 -0.156301 1.08765 -0.156301 0.466135 0.468903C-0.155378 1.09411 -0.155378 2.08802 0.466135 2.71323L11.1912 13.502L0.466135 24.2908C-0.139442 24.916 -0.139442 25.9259 0.466135 26.5351Z" fill="#2E2E2D"></path></svg></div>');
        $('.post-gallery-slider .elementor-image-gallery.first').append('<div class="page"><svg version="1.1" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18 16" style="enable-background:new 0 0 18 16;" xml:space="preserve" class="svg"><path class="st0" d="M16.9,0H1.1C0.8,0,0.5,0.1,0.3,0.3C0.1,0.5,0,0.8,0,1.1v13.7c0,0.3,0.1,0.6,0.3,0.8C0.5,15.9,0.8,16,1.1,16 h15.8c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V1.1c0-0.3-0.1-0.6-0.3-0.8S17.2,0,16.9,0L16.9,0z M3.9,2.3 c0.3,0,0.7,0.1,0.9,0.3C5.1,2.8,5.3,3,5.5,3.3c0.1,0.3,0.2,0.7,0.1,1C5.5,4.7,5.3,5,5.1,5.2C4.8,5.5,4.5,5.6,4.2,5.7 c-0.3,0.1-0.7,0-1-0.1C2.9,5.5,2.7,5.2,2.5,5C2.3,4.7,2.2,4.3,2.2,4c0-0.5,0.2-0.9,0.5-1.2S3.4,2.3,3.9,2.3L3.9,2.3z M2.3,13.1v-2.3 l3.4-3.5C5.7,7.2,5.9,7.2,6,7.2c0.1,0,0.3,0.1,0.4,0.2l1.5,1.4l-4.3,4.4H2.3z M15.8,13.1H5.1l3.5-3.6l3-3.1c0.1-0.1,0.2-0.2,0.4-0.2 c0.1,0,0.3,0.1,0.4,0.2l3.3,3.3V13.1z"/></svg><div class="swiper-pagination"></div></div>');
        $('.post-gallery-slider .elementor-image-gallery .gallery').addClass('swiper-wrapper');
        $('.post-gallery-slider .elementor-image-gallery .gallery-item ').wrap('<div class="swiper-slide">');

        if($('.post-gallery-slider .elementor-image-gallery.first .gallery-item').length <= 1) {
          $('.swiper-button-next').addClass( "hide" );
          $('.swiper-button-prev').addClass( "hide" );
          $('.elementor-image-gallery.thumbs').addClass( "hide" );
        } else {        
          const swiperthumbs = new Swiper(".post-gallery-slider .swiper.thumbs", {
              spaceBetween: 10,
              slidesPerView: "auto",
              freeMode: true,
              watchSlidesProgress: true,
              watchOverflow: true
          });

          const swiper = new Swiper('.post-gallery-slider .swiper.first', {
              autoplay: {
                  delay: 3000,
              },
              centeredSlides: true,
              direction: 'horizontal',
              grabCursor: true,
              loop: true,
              modules: [ Autoplay, Navigation, Pagination, Thumbs ],
              navigation: {
                nextEl: ".post-gallery-slider .swiper-button-next",
                prevEl: ".post-gallery-slider .swiper-button-prev",
              },
              pagination: {
                el: ".swiper-pagination",
                type: "fraction",
              },
              slidesPerView: 1,
              thumbs: {
                swiper: swiperthumbs,
              },
              watchOverflow: true
          });
        }
      }

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/post-gallery-slider.js